import checkboxListView from './checkboxListView.html';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';

export default function checkboxListComponent() {
	return {
		bindings: {
			model: '=',
			items: '<',
			idField: '@?',
			labelField: '@?',
			onChange: '&',
			selectAll: '<',
		},
		controllerAs: 'vm',
		controller: checkboxListComponentCtrl,
		template: checkboxListView,
	};
}

class checkboxListComponentCtrl {
	constructor($scope) {
		'ngInject';
		this.idField = this.idField || 'id';
		this.labelField = this.labelField || 'name';
		this.selectAll = this.selectAll || false;
		$scope.$watchCollection('vm.model', this.onModelChange.bind(this));
	}

	onModelChange() {
		if (!_.isArray(this.model) || !_.isArray(this.items)) {
			return;
		}
		this.processItems();
	}

	processItems() {
		if (this.idField === '*') {
			this.processedItems = ensure.array(this.items).map(item => {
				return {
					id: item,
					label: item,
					checked: this.model.indexOf(item) > -1,
					className: '',
				};
			});
		} else {
			this.processedItems = ensure.array(this.items).map(item => {
				// this is for metadata properties modal
				if (item.prop) {
					// build the new label
					let newLabel = `${item.prop}${item.label ? item.label : item.value}`;
					// truncate if needed
					if (newLabel.length > 70) {
						let truncatedLabel = _.trunc(newLabel, { length: 70 });
						newLabel = truncatedLabel;
					}
					return {
						id: item[this.idField],
						label: newLabel,
						checked: this.model.indexOf(item[this.idField]) > -1,
						className: item.className || '',
					};
				} else {
					return {
						id: item[this.idField],
						label: item[this.labelField],
						checked: this.model.indexOf(item[this.idField]) > -1,
						className: item.className || '',
					};
				}
			});
		}
	}

	$onChanges(changes) {
		if (changes.items) {
			this.onModelChange();
		}
	}

	update(item, evt) {
		try {
			if (evt.target.checked) {
				// add to model array
				item.checked = true;
				this.model.push(item.id);
			} else {
				// remove from model array
				item.checked = false;
				this._remove(item.id);
			}
		} catch (e) {
			console.warn('Ensure that model passed to <sh-checkbox-list> is an array.');
		}
		this.onChange({
			$model: this.model,
			$id: item.id,
			$label: item.label,
			$checked: item.checked,
		});
	}

	updateAll(evt) {
		try {
			// Update the model to either have all options selected, or none.
			this.model = [];
			if (evt.target.checked) {
				this.items.map(item => {
					item.checked = true;
					this.model.push(item.id);
				});
			} else {
				this.items.map(item => {
					item.checked = false;
				});
			}
		} catch (e) {
			console.warn('Issue with select all checkbox');
		}
	}

	_remove(id) {
		let pos = this.model.indexOf(id);
		if (pos > -1) {
			this.model.splice(pos, 1);
		}
	}
}
